// 受取日時チェック
const VALIDATE_VISITTIME = {
  OK: 0, //OK
  NG_COOK: 1, //NG 作成時間チェック
  NG_START: 2, //NG 提供可能時間開始チェック
  NG_END: 3, //NG 提供可能時間終了チェック
  NG_INVALID: -1, //NG その他不正エラー
};

export { VALIDATE_VISITTIME };
